export default __webpack_public_path__ + "static/media/contact_form_close_button.62b210c8.svg";